window.addEventListener('DOMContentLoaded', () => {
    if (typeof gtag === 'undefined') return;

    const el = document.getElementById('ga-data');
    if (!el) return;

    const event = el.dataset.event;
    if (!event) return;

    const d = el.dataset;

    // For view_item: compute nights from ISO dates since the detail page
    // may not have a pre-computed nights value when no quote is present.
    function nightsFromDates() {
        if (!d.checkIn || !d.checkOut) return 1;
        const ms = new Date(d.checkOut) - new Date(d.checkIn);
        return Math.max(1, Math.round(ms / 86400000));
    }

    const handlers = {

        search: () => gtag('event', 'search', {
            search_term:    d.destination   || '',
            destination_id: d.destinationId || '',
            check_in_date:  d.checkIn       || '',
            check_out_date: d.checkOut      || '',
            nights:         Number(d.nights)   || 0,
            adults:         Number(d.adults)   || 0,
            children:       Number(d.children) || 0,
            results_count:  Number(d.results)  || 0
        }),

        view_item: () => gtag('event', 'view_item', {
            currency: d.currency || '',
            value:    Number(d.totalPrice) || 0,
            items: [{
                item_id:       d.propertyId   || '',
                item_name:     d.propertyName || '',
                item_category: d.propertyType || '',
                item_variant:  d.rentScope    || '',
                location_id:   d.location     || '',
                price:         Number(d.pricePerNight) || 0,
                quantity:      nightsFromDates()
            }]
        }),

        begin_checkout: () => gtag('event', 'begin_checkout', {
            currency: d.currency || '',
            value:    Number(d.totalPrice) || 0,
            items: [{
                item_id:   d.propertyId   || '',
                item_name: d.propertyName || '',
                price:     Number(d.pricePerNight) || 0,
                quantity:  Number(d.nights) || 1
            }]
        }),

        purchase: () => gtag('event', 'purchase', {
            transaction_id: d.transactionId || '',
            currency:       d.currency      || '',
            value:          Number(d.totalPrice) || 0,
            items: [{
                item_id:   d.propertyId   || '',
                item_name: d.propertyName || '',
                price:     Number(d.pricePerNight) || 0,
                quantity:  Number(d.nights) || 1
            }],
            check_in_date:  d.checkIn       || '',
            check_out_date: d.checkOut      || '',
            adults:         Number(d.adults)   || 0,
            children:       Number(d.children) || 0,
            nights:         Number(d.nights)   || 0
        })

    };

    const handler = handlers[event];
    if (handler) handler();
});
